import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "./Header.js";
import Sidebar from "./Sidebar.js";
import Footer from "./Footer.js";
//import { BASE_URL } from "./Constants.js";
import useAuth from './useAuth';
import * as XLSX from "xlsx";
import Pagination from './Pagination.js';
import "./Manage_User.css";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Loader = () => (
	<div style={{ textAlign: 'center', marginTop: '20px' }}>
		<div className="spinner-border" role="status">
			<span className="sr-only">Loading...</span>
		</div>
		<p>Loading...</p>
	</div>
);

const Travel_Manager = () => {
	const [EmpCode, setEmpCode] = useState('');
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
    const [RptMgr, setRptMgr] = useState('');
	const [items, setItems] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);
	const [responseMessage, setResponseMessage] = useState('');
	const [is_travelmanager, setis_travelmanager] = useState(false);
	
	const [searchQuery, setSearchQuery] = useState("");
	const [cities, setCities] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [sortColumn, setSortColumn] = useState("sysno");
	const [sortOrder, setSortOrder] = useState("desc");
	const navigate = useNavigate();
	useAuth();
	const token = localStorage.getItem("authToken") || null;
	


    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                if (result.status) {
                    setEmpCode(result.profile.emp_code || '');

                    setRptMgr(result.profile.report_mngr || '');
                    
                    setis_travelmanager(result.profile.is_travelmanager_approved === 'Y');
					
                    // fetchItems(result.profile.emp_code, result.profile.report_mngr);
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchProfileData();
    }, []);
    useEffect(() => {
        const fetchItems = async (EmpCode, RptMgr) => {
            try {
                const token = localStorage.getItem('authToken');
                console.log("RptMgr", RptMgr);
                if (!token) return;

                const response = await fetch(`${API_BASE_URL}getTravelRequest?travel_mngr=${encodeURIComponent(EmpCode)}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("checkresponse", result);
                if (result.status) {
                    setItems(result.travel_request);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };




        if (EmpCode) {
            fetchItems(EmpCode, RptMgr);
        }
    }, [EmpCode, navigate]);
	

	useEffect(() => {
		const fetchCitiesData = async () => {
			try {
				const token = localStorage.getItem('authToken');
				const response = await fetch(`${API_BASE_URL}cities`, {
					method: 'GET',
					headers: {
						'Authorization': `Bearer ${token}`,
						'Content-Type': 'application/json',
					},
				});
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				const result = await response.json();
				if (result.status) {
					setCities(result.data);
				} else {
					setError(result.message);
				}
			} catch (error) {
				console.error('Fetch error:', error);
				setError('Failed to fetch cities data');
			}
		};

		fetchCitiesData();
	}, []);

	useEffect(() => {
		if (!Array.isArray(items)) {
			setFilteredItems([]);
			return;
		}

		const lowerCaseQuery = searchQuery.toLowerCase();

		const filtered = items.filter(item => {
			const trans_code = item.trans_code ? item.trans_code.toLowerCase() : '';
			const comp_name = item.comp_name ? item.comp_name.toLowerCase() : '';
			const report_mngr = item.report_mngr ? item.report_mngr.toLowerCase() : '';
			const no_of_persons = item.no_of_persons ;
			const bank_card = item.bank_card ;
			const source_of_travel = item.source_of_travel ;
			const rpt_mgr_status = item.rpt_mgr_status ? item.rpt_mgr_status.toLowerCase() : '';
			const travel_manager = item.travel_manager ? item.travel_manager.toLowerCase() : '';
			const travel_mngr_status = item.travel_mngr_status ? item.travel_mngr_status.toLowerCase() : '';
			const travel_mngr_amount = item.travel_mngr_amount ? item.travel_mngr_amount.toLowerCase() : '';
			const FromCity = cities.find(city => city.id === item.from_city)?.city_name.toLowerCase() || '';
			const ToCity = cities.find(city => city.id === item.to_city)?.city_name.toLowerCase() || '';
			const travel_date = item.travel_date ? item.travel_date.toLowerCase() : '';
			const empCodes = item.related_details.map(detail => detail.emp_code).join(', ').toLowerCase();

			return (
				trans_code.includes(lowerCaseQuery) ||
				comp_name.includes(lowerCaseQuery) ||
				report_mngr.includes(lowerCaseQuery) ||
				no_of_persons.includes(lowerCaseQuery) ||
				source_of_travel.includes(lowerCaseQuery) ||
				bank_card.includes(lowerCaseQuery) ||
				rpt_mgr_status.includes(lowerCaseQuery) ||
				travel_manager.includes(lowerCaseQuery) ||
				travel_mngr_amount.includes(lowerCaseQuery) ||
				travel_mngr_status.includes(lowerCaseQuery) ||
				FromCity.includes(lowerCaseQuery) ||
				ToCity.includes(lowerCaseQuery) ||
				travel_date.includes(lowerCaseQuery) ||
				empCodes.includes(lowerCaseQuery)
			);
		});

		const sorted = filtered.sort((a, b) => {
			if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
			if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
			return 0;
		});

		setFilteredItems(sorted);
		setCurrentPage(1);
	}, [searchQuery, items, sortColumn, sortOrder, cities]);

	const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

	const startItem = indexOfFirstItem + 1;
	const endItem = Math.min(indexOfLastItem, filteredItems.length);

	const handleSearchChange = e => {
		setSearchQuery(e.target.value);
	};

	const handlePageChange = pageNumber => {
		setCurrentPage(pageNumber);
	};

	const handleItemsPerPageChange = e => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1);
	};

	const handleSort = (column) => {
		if (column === "id") {
			if (sortColumn === column) {
				setSortOrder(sortOrder === "asc" ? "desc" : "asc");
			} else {
				setSortColumn(column);
				setSortOrder("asc");
			}
		}
	};

	const exportToExcel = () => {
		const filteredStateNames = filteredItems.map(item => ({
			TransCode: item.trans_code,
			Name: item.comp_name,
			FromCity: cities.find(city => city.id === item.from_city)?.city_name || 'Unknown City',
			ToCity: cities.find(city => city.id === item.to_city)?.city_name || 'Unknown City',
			report_mngr: item.report_mngr,
			rpt_mgr_status: item.rpt_mgr_status,
			travel_manager: item.travel_manager,
			travel_mngr_status: item.travel_mngr_status,
			travel_mngr_amount: item.travel_mngr_amount,
			travel_date: item.travel_date,
			bank_card: item.bank_card,
			source_of_travel: item.source_of_travel,
			no_of_persons: item.no_of_persons,
			emp_code: item.related_details && item.related_details.length > 0
				? [item.emp_code, ...item.related_details.map(detail => detail.emp_code)].join(', ')
				: item.emp_code || 'N/A',
		}));
		const worksheet = XLSX.utils.json_to_sheet(filteredStateNames);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "TravelRequest");
		XLSX.writeFile(workbook, "TravelRequest.xlsx");
	};

	return (
		<>
			<div className='hold-transition sidebar-mini layout-fixed' style={{ fontSize: '12px' }}>
				<div className='wrapper'>
					<Header />
					<Sidebar />
					<div className='content-wrapper'>
						<div className='content-header'>
							<div className='container-fluid'>
								<div className='row mb-2'>
									<div className='col-sm-6'>
										<h1 className='m-0' style={{ fontSize: '20px' }}>Travel Request Details</h1>
									</div>
									<div className='col-sm-6'>
										<ol className='breadcrumb float-sm-right'>
											<li className='breadcrumb-item' style={{ fontSize: '12px' }}>
												<Link to='/dashboard'>Home</Link>
											</li>
											<li className='breadcrumb-item active' style={{ fontSize: '12px' }}>Travel Request Details</li>
										</ol>
									</div>
								</div>
							</div>
						</div>
						<section className='content'>
							<div className='container-fluid'>
								<div className='row'>
									<section className='col-lg-12 connectedSortable'>
										<div className='card'>
											<div className='card-header'>
												<span style={{ float: "right" }}>
													{/* <Link to='/travel_request'>
														<button type='button' className='btn btn-success'>Add New</button>
													</Link> */}
													<button type='button' className='btn btn-secondary ml-2' onClick={exportToExcel}>Export to Excel</button>
												</span>
											</div>
											<div className='card-body'>
												{loading ? (
													<Loader />
												) : (
													<>
														<div id='example1_filter' style={{ float: "right" }} className='dataTables_filter'>
															<label>
																<input
																	type='search'
																	value={searchQuery}
																	onChange={handleSearchChange}
																	className='form-control form-control-sm'
																	placeholder='Search'
																	aria-controls='example1'
																/>
															</label>
														</div>

														<div className='form-group'>
															<select
																className='form-control custom-select-sm'
																value={itemsPerPage}
																onChange={handleItemsPerPageChange}>
																<option value={10}>10</option>
																<option value={50}>50</option>
																<option value={100}>100</option>
															</select>
														</div>
														<div className="table-responsive">
															<table className='table table-bordered table-striped' style={{ fontSize: '13px' }}>
																<thead>
																	<tr>
																			<th onClick={() => handleSort("id")}>
																				ID {sortColumn === "id" && (sortOrder === "asc" ? "▲" : "▼")}
																			</th>
																			<th>Trans Code</th>
																			<th>Name</th>
																			<th>From City</th>
																			<th>To City</th>
																			<th>Travel Date</th>
																			<th>Emp Code</th>
																			<th>Age</th>
																			<th>Way</th>
                                                                            <th>Reporting Manager</th>
                                                                            <th>Reporting Manager Status</th>
                                                                            <th>Travel Desk</th>
                                                                            <th>Travel Desk Status</th>
																			<th>Ticket Price</th>
																			<th>Source</th>
																			<th>Card</th>
																			<th>No of Persons</th>
																			<th>Action</th>
																	</tr>
																</thead>
																<tbody>
																	{is_travelmanager && currentItems.length > 0 ? (
																		currentItems.map((item, index) => {
																			const fromCity = cities.find(city => city.id === item.from_city)?.city_name || 'Unknown City';
																			const toCity = cities.find(city => city.id === item.to_city)?.city_name || 'Unknown City';

																			return (
																				<tr key={index}>
																					<td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
																					<td>{item.trans_code}</td>
																					<td>{item.comp_name}</td>
																					<td>{fromCity}</td>
																					<td>{toCity}</td>
																					<td>{item.travel_date}</td>
                                                                                    
																					<td>
																						{item.related_details && item.related_details.length > 0
																							? [
																								item.emp_code,
																								...item.related_details.map(detail => detail.emp_code)
																							]
																								.filter((value, index, self) => self.indexOf(value) === index)  // Remove duplicates
																								.join(', ')
																							: item.emp_code || 'N/A'}
																					</td>
																					<td>{item.age}</td>
																					<td>{item.way}</td>
                                                                                    <td>{item.report_mngr}</td>
																					<td style={{
                                                                                    color: item.rpt_mgr_status === 'Pending' ? 'orange' :
                                                                                        item.rpt_mgr_status === 'Rejected' ? 'red' :
                                                                                            item.rpt_mgr_status === 'Approved' ? 'green' :
                                                                                                'inherit'
                                                                                }}>
                                                                                    {item.rpt_mgr_status}
                                                                                </td>
																				<td>{item.travel_manager ? item.travel_manager : "Need to Approval by Travel Manager To Display"}</td>

                                                                                <td style={{
                                                                                    color: item.travel_mngr_status === 'Pending' ? 'orange' :
                                                                                        item.travel_mngr_status === 'Rejected' ? 'red' :
                                                                                            item.travel_mngr_status === 'Approved' ? 'green' :
                                                                                                'inherit'
                                                                                }}>
                                                                                    {item.travel_mngr_status}
                                                                                </td>
																				<td>{Math.trunc(item.travel_mngr_amount)}</td>
																				<td>{item.source_of_travel}</td>
																				<td>{item.bank_card}</td>
																				<td>{item.no_of_persons}</td>
																					<td>
																					{item.rpt_mgr_status === 'Approved' && (
																						<Link to={`/edit_travel_manager_form/${item.id}`}>
																							<i className="fa fa-edit" style={{ fontSize: '12px', color: 'green' }}></i>
																						</Link>
																						)}
																					</td>
																				
																				</tr>
																			);
																		})
																	) : (
																		<tr>
																			<td colSpan='10'><center>No data available</center></td>
																		</tr>
																	)}
																</tbody>
															</table>
														</div>
													</>
												)}
											</div>
										</div>
										<Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                handlePageChange={handlePageChange}
                                            />
										<div className='mb-3'>
											Showing {startItem} to {endItem} of {filteredItems.length} entries
										</div>
									</section>
								</div>
							</div>
						</section>
					</div>
					<Footer />
					<aside className='control-sidebar control-sidebar-dark'></aside>
				</div>
			</div>
		</>
	);
};

export default Travel_Manager;
